import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BreakpointService } from '@services';
import { FullscreenMobileModalConfig } from '@shared/ui/ui.constants';
import { isBoolean } from 'lodash';
import { ConfirmDialogModernComponent, ConfirmDialogModernConfig } from './confirm-dialog-modern.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogModernService {

  constructor(
    private dialog: MatDialog,
    private breakpointService: BreakpointService,
  ) {
  }

  private dialogRef: MatDialogRef<ConfirmDialogModernComponent> | null = null;

  public get confirmRef(): ConfirmDialogModernComponent {
    return this.dialogRef.componentInstance;
  }

  confirm(config: ConfirmDialogModernConfig): void {
    this.dialogRef = this.dialog.open(ConfirmDialogModernComponent, {
      ...(this.breakpointService.isMobile
        ? FullscreenMobileModalConfig
        : {
          panelClass: 'no-padding',
          maxWidth: '640px',
        }),
      data: config,
      autoFocus: false,
      restoreFocus: isBoolean(config.restoreFocus) ? config.restoreFocus : true,
    });
  }

  close(): void {
    this.dialogRef?.close();
  }
}
